import React, { useState, useEffect } from 'react';
import { FormField, Select } from '../../../components/ui/Form';
import { Button } from '../../../components/ui/Button';
import { Card } from '../../../components/ui/Card';
import { CURRENCIES, CurrencyCode } from '../../../config/currency';
import { useSettings } from '../../../hooks/useSettings';
import toast from 'react-hot-toast';

export function GeneralSettings() {
  const { settings, loading, updateSettings } = useSettings();
  
  const [language, setLanguage] = useState('fr');
  const [dateFormat, setDateFormat] = useState('DD/MM/YYYY');
  const [timezone, setTimezone] = useState('Africa/Kinshasa');
  const [theme, setTheme] = useState('light');
  const [baseCurrency] = useState<CurrencyCode>('CDF');
  const [displayCurrency, setDisplayCurrency] = useState<CurrencyCode>('CDF');
  const [isSaving, setIsSaving] = useState(false);
  
  // Charger les paramètres depuis le hook
  useEffect(() => {
    if (settings?.general) {
      setLanguage(settings.general.language);
      setDateFormat(settings.general.dateFormat);
      setTimezone(settings.general.timezone);
      setTheme(settings.general.theme);
      setDisplayCurrency(settings.general.displayCurrency as CurrencyCode);
    }
  }, [settings]);
  
  const handleSavePreferences = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSaving(true);
    
    try {
      await updateSettings({
        category: 'general',
        settings: {
          ...settings?.general,
          language,
          dateFormat,
          timezone,
          theme,
          baseCurrency,
          displayCurrency,
        }
      });
      
      toast.success('Préférences enregistrées avec succès');
    } catch (error) {
      console.error('Erreur lors de la sauvegarde:', error);
      toast.error('Erreur lors de la sauvegarde des préférences');
    } finally {
      setIsSaving(false);
    }
  };
  if (loading) {
    return (
      <div className="space-y-6">
        <Card title="Préférences générales">
          <p className="text-center py-4">Chargement des paramètres...</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Card title="Préférences générales">
        <form className="space-y-6" onSubmit={handleSavePreferences}>
          <div className="grid grid-cols-2 gap-6">
            <FormField label="Langue par défaut">
              <Select value={language} onChange={(e) => setLanguage(e.target.value)}>
                <option value="fr">Français</option>
                <option value="en">English</option>
              </Select>
            </FormField>

            <FormField label="Fuseau horaire">
              <Select value={timezone} onChange={(e) => setTimezone(e.target.value)}>
                <option value="Africa/Kinshasa">CAT (UTC+2)</option>
                <option value="UTC">UTC</option>
              </Select>
            </FormField>

            <FormField label="Format de date">
              <Select value={dateFormat} onChange={(e) => setDateFormat(e.target.value)}>
                <option value="DD/MM/YYYY">JJ/MM/AAAA</option>
                <option value="YYYY-MM-DD">AAAA-MM-JJ</option>
                <option value="MM/DD/YYYY">MM/JJ/AAAA</option>
              </Select>
            </FormField>

            <FormField label="Thème">
              <Select value={theme} onChange={(e) => setTheme(e.target.value)}>
                <option value="light">Clair</option>
                <option value="dark">Sombre</option>
                <option value="auto">Automatique</option>
              </Select>
            </FormField>

            <FormField label="Devise d'affichage">
              <Select
                value={displayCurrency}
                onChange={(e) => setDisplayCurrency(e.target.value as CurrencyCode)}
              >
                {Object.values(CURRENCIES).map(currency => (
                  <option key={currency.code} value={currency.code}>
                    {currency.name} ({currency.symbol})
                  </option>
                ))}
              </Select>
            </FormField>
          </div>

          <div className="flex justify-end">
            <Button type="submit" disabled={isSaving}>
              {isSaving ? 'Enregistrement...' : 'Enregistrer les préférences'}
            </Button>
          </div>
        </form>
      </Card>
      

    </div>
  );
}